<template>
  <div class="shoopingCart">
    <layout>
      <div class="contentBox" slot="content">
        <span @click="changeState()" v-if="State" class="title">编辑</span>
        <span @click="changeState()" v-else class="title">完成</span>
        <div>
          <div class="list" v-if="goldList.length >= 1">
            <div
              class="listBox"
              v-for="(item, index) in goldList"
              :key="index"
              :class="item.icon"
            >
              <div class="listLeft">
                <div class="listLeftText">
                  <van-checkbox
                    class="listLeftTextCheck"
                    v-model="item.checkBOx"
                    @change="handleCheckthis(item, index)"
                    checked-color="#272727"
                  ></van-checkbox>
                  <img
                    :src="item.image[0].file_path | thumbnail(720, 720)"
                    class="listLeftImg"
                    alt=""
                  />
                  <div class="contain">
                    <span class="top">{{ item.goods_name }}</span>
                    <div class="head">
                      <span class="headName">产品编号:</span
                      >{{ item.goods_number }}
                    </div>
                    <div class="mid">
                      <span class="midText">(金)材质:</span
                      ><span class="midTextnr">{{
                        item.goods_sku.material
                      }}</span
                      >|<span class="midTextfj">克重:</span
                      ><span>{{ item.goods_sku.goods_weight }}克</span>
                      <div
                        style="display:inline"
                        v-if="item.goods_sku.goods_size"
                      >
                        <span class="midTextfj">| 尺寸:</span
                        ><span>{{ item.goods_sku.goods_size }}cm</span>
                      </div>
                    </div>
                    <!-- <div class="bt" v-if="userType">
                      <span class="btText">销售工费（g）:</span
                      ><span class="btTextnr"
                        >￥{{ item.goods_sku.goods_sell_wage }}</span
                      ><span class="btTextfj">销售附加工费（件）:</span
                      ><span>￥{{ item.goods_sku.goods_add_sell_wage }}</span>
                    </div> -->
                  </div>
                </div>
                <div class="listRightText">
                  <div
                    class="listRightIMG iconfont iconashbin ic"
                    @click="deleteList($event, item)"
                  ></div>

                  <van-stepper
                    :disable-input="true"
                    v-model="item.total_num"
                    @plus="plusNum($event, item)"
                    @minus="minusNum($event, item)"
                    min="1"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="list2" v-else>
            <img
              src="@/assets/img/b6e916ae5982d2d3bebca61033ce2e4.png"
              alt=""
            />
            <p>购物车空空如也~</p>
          </div>
        </div>
        <div class="under">
          <div class="underLeft">
            <van-checkbox
              class="underCheckBox"
              v-model="AllChecked"
              @change="handleCheckAll"
              checked-color="#272727"
            ></van-checkbox>
            <span class="underAll">全选</span>
          </div>
          <div style="display: flex">
            <span class="selected">已选{{ total }}件</span>
            <div class="underRight" v-if="State" @click="SureCart">下单</div>
            <div class="underRight" v-else @click="delateBt">删除</div>
          </div>
        </div>
      </div>
    </layout>
  </div>
</template>
<script>
import {
  orderList,
  orderStatus,
  shoppCarList,
  addCard,
  minuCard,
  delateCard
} from "../../api/http.js";
import { Dialog } from "vant";
import layout from "@/components/layout.vue";
import { TorusKnotGeometry } from "three";
export default {
  components: {
    layout
  },

  data() {
    return {
      userType: null,
      value: 1,
      cheList: [],
      checked: false,
      AllChecked: false,
      State: true,
      goldList: [],
      swiperOption: {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        loopedSlide: 5,
        autoplay: false
      },
      total: 0
    };
  },
  created() {
    this.onloadLIst();
    if (localStorage.getItem("user_type") == "wholesaler_user") {
      this.userType = false;
    } else {
      this.userType = true;
    }
  },
  activated() {
    this.onloadLIst();
  },
  computed: {
    imgheight() {
      return (this.$store.state.screenHeight - 175) / 102.4;
    }
  },
  methods: {
    SureCart() {
      console.log("aaa", this.cheList);
      if (this.cheList.length == 0) {
        this.$toast("请选中商品");
        return;
      }
      var goods_sku_id = this.cheList.join(",");
      console.log(goods_sku_id);
      this.$router.push({
        path: "/orderCheckout",
        query: {
          ids: goods_sku_id
        }
      });
    },
    delateBt() {
      let _this = this;
      if (_this.cheList.length == 0) {
        _this.$toast("请选中商品");
      } else {
        Dialog.confirm({
          title: "您确定要移除选择的商品吗",
          width: "40%"
        }).then(() => {
          let token = localStorage.getItem("login_token");
          console.log(_this.cheList);
          var goods_sku_id = _this.cheList.join(",");
          delateCard(goods_sku_id, token).then(res => {
            _this.$toast("删除成功");
            shoppCarList(token).then(res => {
              this.$store.commit("cart", res.data.goods_list.length);
            });
            _this.onloadLIst();
            this.total = 0;
          });
        });
      }
    },
    deleteList(e, i) {
      let _this = this;
      Dialog.confirm({
        title: "您确定要移除选择的商品吗",
        width: "40%"
      }).then(() => {
        let token = localStorage.getItem("login_token");
        var goods_sku_id = i.goods_id + "_" + i.goods_sku_id;
        var goods_sku_id_text = i.goods_id;
        delateCard(goods_sku_id, token).then(res => {
          _this.$toast("删除成功");
          // this.total--;
          shoppCarList(token).then(res => {
            this.$store.commit("cart", res.data.goods_list.length);
          });
          // if (this.total == 0) {
          //   this.total = 0;
          // }
          _this.goldList = _this.goldList.filter(function(e, index) {
            return e.goods_id != goods_sku_id_text;
          });
          // _this.goldList.forEach(function(e, index) {
          // if (e.goods_id == goods_sku_id_text) {
          //   _this.goldList.splice(index, 1);
          //   console.log("splice");
          // }
          // });
        });
      });
    },
    minusNum(e, i) {
      var goods_id = i.goods_id;
      var goods_sku_id = i.goods_sku_id;
      let token = localStorage.getItem("login_token");
      let _this = this;
      minuCard(goods_id, goods_sku_id, token).then(res => {});
    },
    handleCheckthis(e, index) {
      if (e.checkBOx) {
        this.cheList = new Set(this.cheList);
        this.cheList.add(e.goods_id + "_" + e.goods_sku_id);
        // this.total = this.cheList.size;
        this.total++;
        this.cheList = [...this.cheList];
      } else {
        this.total--;
        this.cheList = this.cheList.filter(function(ele, index) {
          return ele != e.goods_id + "_" + e.goods_sku_id;
        });
        // this.cheList.splice(
        //   this.cheList.findIndex(
        //     item => item === e.goods_id + "_" + e.goods_sku_id
        //   ),
        //   1
        // );
        if (this.total < 0) {
          this.total = 0;
        }
      }
    },
    handleCheckAll(val) {
      let _this = this;
      _this.AllChecked = val;
      _this.goldList.forEach(e => {
        _this.$set(e, "checkBOx", val);
      });
    },
    plusNum(e, i) {
      var goods_id = i.goods_id;
      var goods_num = 1;
      var goods_sku_id = i.goods_sku_id;
      let token = localStorage.getItem("login_token");
      let _this = this;
      addCard(goods_id, goods_num, goods_sku_id, token).then(res => {});
    },

    changeState() {
      this.State = !this.State;
    },
    onloadLIst() {
      let token = localStorage.getItem("login_token");
      let _this = this;
      shoppCarList(token).then(res => {
        res.data.goods_list;
        _this.goldList = res.data.goods_list;
        _this.goldList.forEach(e => {
          _this.$set(e, "checkBOx", false);
        });
        this.total = 0;
      });
    }
  }
};
</script>
<style>
.van-stepper__input[disabled] {
  color: #000;
}
</style>
<style lang="scss" scoped>
.list2 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  img {
    width: 150px;
  }
  p {
    font-size: 15px;
    margin: 0;
    margin-top: 10px;
    color: #0e0e0e;
  }
}
.selected {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 200px;
  color: #0e0e0e;
  font-size: 15px;
}
.category-wrapper {
  width: 100vw;
  overflow: hidden;
}
/deep/.content_1 {
  position: fixed !important;
  height: 100%;
  padding-bottom: 0 !important;
}
.con {
  position: relative;
  display: flex;
  padding-left: 139px;
  height: 100vh;
  width: 100vw;
  background: #ececec;
  overflow: hidden;
  // box-sizing: border-box;
  // -webkit-overflow-scrolling: touch;
  // overflow-scrolling: touch;
}
.shoopingCart {
  width: 100%;
  overflow: hidden;
  layout {
    height: 100%;
  }
}
.contentBox {
  height: 100%;
  background: #efefef;

  .title {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #0e0e0e;
    display: inline-block;
    margin: 10px 20px;
    padding-top: 10px;
  }
  .list {
    position: fixed;
    bottom: 60px;
    width: 100%;
    top: 100px;
    overflow-y: scroll;
    overflow-x: hidden;
    .listBox {
      background: #fff;
      width: 100%;

      .listLeft {
        display: flex;
        justify-content: space-between;
        border-bottom: 0.1px solid #f1f1f1;
        margin: 0 15px;
        .listLeftText {
          display: flex;
          .listLeftTextCheck {
            height: 30px;
            width: 30px;
            margin: auto 0;
            // /deep/.van-checkbox__icon--round{
            //     border-color: #747474;
            // }
          }
          .listLeftText:checked:after {
            background-color: #19874f;
          }
          .listLeftImg {
            width: 95px;
            height: 95px;
            background: #0e0e0e;
            margin: 10px 5px;
            border-radius: 4px;
          }
          .contain {
            line-height: 25px;
            margin-left: 5px;
            padding: 5px 0;
            .top {
              font-size: 13px;
              font-family: PingFang SC;
              font-weight: 600;
              color: #201f26;
            }
            .head {
              font-size: 13px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #201f26;
              .headName {
                color: #747474;
                margin-right: 8px;
              }
            }
            .mid {
              font-size: 13px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #201f26;

              .midText {
                color: #747474;
                margin-right: 5px;
              }
              .midTextfj {
                color: #747474;
                padding-left: 5px;
                // border-left: 1px solid #201f26;
              }
              .midTextnr {
                padding-right: 5px;
              }
            }
            .bt {
              font-size: 13px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #201f26;

              .btText {
                color: #747474;
                margin-right: 5px;
              }
              .btTextfj {
                color: #747474;
                padding-left: 5px;
                border-left: 1px solid #201f26;
              }
              .btTextnr {
                padding-right: 5px;
              }
            }
          }
        }
        .listRightText {
          .listRightIMG {
            font-size: 20px;
            margin: 12px 23px 35px 50px;
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }
  .list::-webkit-scrollbar-thumb {
    opacity: 0.95;
    background: rgba(15, 18, 19, 0.6);
    border: 1px solid;
    border-radius: 4px;
  }

  .list::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    width: 6px;
    height: 10px;
  }

  .list::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 8px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .under {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    position: fixed;
    // border-top: 0.5px solid #f1f1f1;
    bottom: 0;
    .underLeft {
      display: flex;
      margin-left: 20px;
      .underCheckBox {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        // height: 64px;
        // width: 23px;
        // margin: 20px 0;
      }
      .underCheck:checked {
        background: black;
      }
      .underCheck {
        width: 25px;
        height: 25px;
        background-color: #ffffff;
        border: solid 1px #dddddd;
        -webkit-border-radius: 50%;
        border-radius: 50%;
        font-size: 0.8rem;
        margin: auto 10px;
        padding: 0;
        border: 1px solid;
        position: relative;
        display: inline-block;
        vertical-align: top;
        cursor: default;
        -webkit-appearance: none;
        -webkit-user-select: none;
        user-select: none;
        -webkit-transition: background-color ease 0.1s;
        transition: background-color ease 0.1s;
      }
      .underCheck:checked::after {
        content: "";
        top: 5px;
        left: 5px;
        position: absolute;
        background: transparent;
        border: #fff solid 2px;
        border-top: none;
        border-right: none;
        height: 6px;
        width: 10px;
        -moz-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
      }
      .underAll {
        display: block;
        margin: auto;
        margin-left: 23px;
        height: 60px;
        width: 30px;
        padding: 5px;
        line-height: 58px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #0e0e0e;
      }
      .aa {
        height: 65px;
        width: 65px;
        margin: auto;
        padding: 5px;
      }
    }
  }
  .underRight {
    width: 182px;
    height: 66px;
    background: #0e0e0e;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 66px;
  }
}
</style>
